import React, { Suspense } from 'react';
import { Switch, BrowserRouter } from 'react-router-dom';
import Charting from '../screens/Charting';
//import Home from '../screens/Home';

const NotFound = React.lazy(() => import('./../screens/NotFound'));

export default function() {
  return (
    <Suspense fallback={null}>
      <BrowserRouter>
        <Switch>
          <Charting exact path="/charting" />
          <NotFound exact status={404} />
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}
